import { DocumentEditor as DocumentEditorCmp } from './DocumentEditor';
import { DocumentEditorContextProvider } from './contexts/DocumentEditorContext';
import { DocumentResolverContextProvider } from './contexts/DocumentResolverContext';

import type { Editable } from './types/editable.type';
import type { DocumentEditorProps } from './types/props.type';

export { pathToChapters } from './utils/path-to-chapters.util';
export type { PrintGroup } from './types/print-group.type';

export const DocumentEditor = <E extends Editable>(
  props: Readonly<DocumentEditorProps<E>>,
) => {
  const { reinitKey } = props;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DocumentEditorContextProvider key={reinitKey} {...props}>
      <DocumentResolverContextProvider>
        <DocumentEditorCmp />
      </DocumentResolverContextProvider>
    </DocumentEditorContextProvider>
  );
};
